"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _iterables = require("rich-text-lib/utils/iterables");

var _InsertLinkPopoverBody = _interopRequireDefault(require("rich-text-lib/components/links/InsertLinkPopoverBody"));

var _link = require("rich-text-lib/constants/link");

var _usageTracking = require("../constants/usageTracking");

var _usageTracking2 = require("../utils/usageTracking");

var _TinyMcePopover = _interopRequireDefault(require("../components/TinyMcePopover"));

var LinkInsertPopover =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(LinkInsertPopover, _Component);

  function LinkInsertPopover(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LinkInsertPopover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LinkInsertPopover).call(this, props));
    _this.state = (0, _extends2.default)({}, _this._getInitialState(), {
      linkText: props.selectedText
    });
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUpdate = _this.handleUpdate.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsertAfterClose = _this.handleInsertAfterClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseComplete = _this.handleCloseComplete.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLinkTypeChange = _this.handleLinkTypeChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LinkInsertPopover, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var open = _ref.open,
          selectedText = _ref.selectedText;

      if (open && !this.props.open) {
        this.setState((0, _extends2.default)({}, this._getInitialState(), {
          linkText: selectedText
        }));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.removeUnInsertedLinks();
    }
  }, {
    key: "handleInsertAfterClose",
    value: function handleInsertAfterClose() {
      this.props.editor.off('closelinkpopover', this.handleInsertAfterClose);
    } // Prefixed with _ to deal with silly warning in our version of React

  }, {
    key: "_getInitialState",
    value: function _getInitialState() {
      return {
        href: '',
        externalLink: false,
        noFollow: false,
        linkText: '',
        fetchedPages: [],
        likelyUrlMatches: false,
        fileMeta: null,
        linkType: _link.LinkTypes.URL
      };
    }
  }, {
    key: "handleInsert",
    value: function handleInsert() {
      var _this2 = this;

      this.setState({
        isInsert: true
      }, function () {
        _this2.props.onRemove();
      });
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(linkInfo) {
      if (_link.CacheableLinkTypes.includes(this.state.linkType) && linkInfo.href) {
        this.props.updateCache(linkInfo.href, (0, _extends2.default)({}, linkInfo, {
          linkType: this.state.linkType
        }));
      }

      this.setState(linkInfo);
    }
  }, {
    key: "handleCloseComplete",
    value: function handleCloseComplete() {
      if (this.state.isInsert) {
        this.props.onInsert(this.state);
        this.trackLinkInsertion();
      }

      this.props.removeUnInsertedLinks();
    }
  }, {
    key: "handleLinkTypeChange",
    value: function handleLinkTypeChange(linkType) {
      this.setState({
        linkType: linkType,
        externalLink: linkType === _link.LinkTypes.MEETING
      });
    }
  }, {
    key: "trackLinkInsertion",
    value: function trackLinkInsertion() {
      (0, _usageTracking2.trackInteraction)(this.props.editor, 'tinymceLink', _usageTracking.INSERT_LINK, (0, _extends2.default)({}, (0, _iterables.pick)(_link.TrackableLinkFields, this.state)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          editor = _this$props.editor,
          onRemove = _this$props.onRemove,
          target = _this$props.target,
          fetchPages = _this$props.fetchPages,
          fetchMeetings = _this$props.fetchMeetings,
          fetchAnchors = _this$props.fetchAnchors,
          mountedToText = _this$props.mountedToText,
          onSelectFile = _this$props.onSelectFile,
          showRefAndTargetControls = _this$props.showRefAndTargetControls,
          useEmailSubscription = _this$props.useEmailSubscription,
          allowFileDownload = _this$props.allowFileDownload,
          allowMeetingLink = _this$props.allowMeetingLink,
          allowAnchorLinks = _this$props.allowAnchorLinks,
          open = _this$props.open,
          children = _this$props.children,
          cache = _this$props.cache;
      var _this$state = this.state,
          href = _this$state.href,
          externalLink = _this$state.externalLink,
          noFollow = _this$state.noFollow,
          linkType = _this$state.linkType,
          fileMeta = _this$state.fileMeta,
          linkText = _this$state.linkText;
      return _react.default.createElement(_TinyMcePopover.default, {
        open: open,
        target: target,
        editor: editor,
        arrowSize: mountedToText ? 'medium' : 'none',
        placement: mountedToText ? 'bottom' : 'bottom right',
        onRemove: onRemove,
        closeOnOutsideClick: !mountedToText,
        onOpenChange: !mountedToText ? onRemove : null,
        onCloseComplete: this.handleCloseComplete,
        animateOnToggle: false,
        isToolbarPopover: true,
        content: _react.default.createElement(_InsertLinkPopoverBody.default, {
          cache: cache,
          dropdownClassName: "mce-ui-select",
          href: href,
          externalLink: externalLink,
          noFollow: noFollow,
          linkText: linkText,
          linkType: linkType,
          fileMeta: fileMeta,
          fetchPages: fetchPages,
          fetchMeetings: fetchMeetings,
          fetchAnchors: fetchAnchors,
          onClose: onRemove,
          onLinkTypeChange: this.handleLinkTypeChange,
          onUpdate: this.handleUpdate,
          onInsert: this.handleInsert,
          onSelectFile: onSelectFile,
          showRefAndTargetControls: showRefAndTargetControls,
          useEmailSubscription: useEmailSubscription,
          allowFileDownload: allowFileDownload,
          allowMeetingLink: allowMeetingLink,
          allowAnchorLinks: allowAnchorLinks,
          canModifyLinkText: !mountedToText,
          scopes: editor.settings.scopes,
          userId: editor.settings.userId
        })
      }, children);
    }
  }]);
  return LinkInsertPopover;
}(_react.Component);

exports.default = LinkInsertPopover;
LinkInsertPopover.propTypes = {
  open: _react.PropTypes.bool.isRequired,
  editor: _react.PropTypes.object.isRequired,
  onRemove: _react.PropTypes.func.isRequired,
  target: _react.PropTypes.instanceOf(HTMLElement),
  selectedText: _react.PropTypes.string,
  fetchPages: _react.PropTypes.func.isRequired,
  fetchMeetings: _react.PropTypes.func.isRequired,
  fetchAnchors: _react.PropTypes.func.isRequired,
  onInsert: _react.PropTypes.func.isRequired,
  mountedToText: _react.PropTypes.bool.isRequired,
  onSelectFile: _react.PropTypes.func.isRequired,
  showRefAndTargetControls: _react.PropTypes.bool.isRequired,
  cache: _react.PropTypes.object.isRequired,
  updateCache: _react.PropTypes.func.isRequired,
  useEmailSubscription: _react.PropTypes.bool,
  allowFileDownload: _react.PropTypes.bool,
  allowMeetingLink: _react.PropTypes.bool,
  allowAnchorLinks: _react.PropTypes.bool,
  children: _react.PropTypes.object,
  removeUnInsertedLinks: _react.PropTypes.func
};
module.exports = exports.default;